import { type RestaurantTagType } from '@discover-data/stores/restaurant/gql/fragments/restaurantTag';
import { type SuburbType } from '@discover-data/gql/fragments/suburb';
import { type PeopleOption } from '@discover-data/stores/hooks/people/options';
import { useModal } from '@context/ModalContext';
import IconMapM from '@firsttable/web-components/atoms/Icon/IconMapM';
import { TrackProvider } from '@components/analytics/context/AnalyticsContext';
import Button from '@components/analytics/components/Button';
import useMapQueryState from './useMapQueryState';
import useSyncMapState from './syncMapState';
import MapModal from './modal';

export type MapButtonProps = {
  defaultViewState: ViewState;
  tags: RestaurantTagType[];
  suburbs: SuburbType[];
  className?: string;
  peopleOptions?: PeopleOption[] | null;
  minDiners?: PeopleOption | null;
  maxDiners?: PeopleOption | null;
};

export default function MapButton({
  defaultViewState,
  tags,
  suburbs,
  peopleOptions,
  minDiners,
  maxDiners,
  ...props
}: MapButtonProps) {
  const { showModal, hideModal, isModalOpen } = useModal();
  const [, setMapState] = useMapQueryState();

  useSyncMapState(defaultViewState, tags, suburbs, peopleOptions, minDiners, maxDiners);

  return (
    <TrackProvider button_name="toggle map/list" button_type="navigation">
      <Button
        Icon={IconMapM}
        kind="outline"
        size="l"
        wide
        onClick={() => {
          setMapState(true);
          if (!isModalOpen) {
            showModal(
              <MapModal
                defaultViewState={defaultViewState}
                tags={tags}
                suburbs={suburbs}
                peopleOptions={peopleOptions}
                minDiners={minDiners}
                maxDiners={maxDiners}
              />,
              {
                showCloseIcon: false,
                disableEscExit: true,
                onRequestClose: hideModal,
                hideOnRouteChange: false,
              }
            );
          }
        }}
        {...props}>
        View map
      </Button>
    </TrackProvider>
  );
}
